import component from "containers/StaticPages/pages/Partners";

export default {
  key: "partners",
  title: "Partners",
  path: "/:user?/partners",
  pageName: "partners",
  linkTarget: "/partners",
  component,
};
